'use strict';

module.exports =
	'<li class="ad-component_list--item ad-component_dropdown <%= className %>">' +
		'<a class="ad-component--link ad-component_dropdown--trigger <%= linkClassName %>" href="javascript:;"><%= label %></a>' +
		'<%= listContainer %>' +
	'</li>';



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/templates/ad-dropdown.tpl.js
// module id = 36
// module chunks = 0